import "vue-toastification/dist/index.css";
import Vue from 'vue';
import Toast from "vue-toastification";

Vue.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true
});